// BootstrapのJSをすべてインポート
import * as bootstrap from 'bootstrap'